import { render, staticRenderFns } from "./PublisherField.vue?vue&type=template&id=33935b98&scoped=true&"
import script from "./PublisherField.vue?vue&type=script&lang=js&"
export * from "./PublisherField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33935b98",
  null
  
)

export default component.exports